import logger from "../../../utils/logger";
import {
  loadPins,
  loadRemedies,
  markPin,
  setPins,
  setRemedies,
} from "../reducer/remedies";
import * as uiActions from "../reducer/ui";

const loadRemediesFlow =
  ({ getRemedyList }) =>
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    next(action);
    if (action.type === loadRemedies.type) {
      dispatch(uiActions.setLoading(true));
      try {
        const response = await getRemedyList();
        // dispatch(loadRemediesSuccess(response.data));
        logger()(response.data);
        const pins = getState().remedies.pinArray;
        //remove invalid pins
        const newPins = pins.filter((pin) =>
          response.data.data.map((it) => it._id).includes(pin)
        );
        logger()(pins, newPins);
        dispatch(setPins(newPins));
        //set pinned field and apply sort
        dispatch(setRemedies(calcPins(response.data.data, newPins)));
      } catch (error) {
        if (error.response && error.response.data && error.response.data.msg) {
          dispatch(uiActions.setError(error.response.data.msg));
        } else dispatch(uiActions.setError(error.message));
      }
      dispatch(uiActions.setLoading(false));
    }
  };

const calcPins = (list, pins) => {
  return list
    .map((item) => ({
      ...item,
      pinned: pins.findIndex((id) => id === item._id),
    }))
    .sort((a, b) => b.pinned - a.pinned);
};

const loadPinsFlow =
  ({}) =>
  ({ dispatch }) =>
  (next) =>
  async (action) => {
    next(action);
    if (action.type === loadPins.type) {
      dispatch(uiActions.setLoading(true));
      try {
        const data = JSON.parse(localStorage.getItem("remedy-pins"));
        logger()(data);
        if (data) dispatch(setPins(data));
      } catch (error) {
        dispatch(uiActions.setError(error.message));
      }
      dispatch(uiActions.setLoading(false));
    }
  };

const markPinFlow =
  ({}) =>
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    next(action);
    if (action.type === markPin.type) {
      try {
        const resList = getState().remedies.remedyList;
        const pins = getState().remedies.pinArray;
        if (action.payload.value) {
          if (pins.length === 3) {
            dispatch(uiActions.setError("Max 3 Bookmarks allowed"));
          } else {
            // pin = true
            const newPins = [...pins, action.payload.id];
            dispatch(setPins(newPins));
            dispatch(setRemedies(calcPins(resList, newPins)));
            localStorage.setItem("remedy-pins", JSON.stringify(newPins));
          }
        } else {
          // pin = false
          const newPins = pins.filter((pin) => pin !== action.payload.id);
          dispatch(setPins(newPins));
          dispatch(setRemedies(calcPins(resList, newPins)));
          localStorage.setItem("remedy-pins", JSON.stringify(newPins));
        }
      } catch (error) {
        // dispatch(uiActions.setError(error.message));
      }
    }
  };

const remediesFlow = [loadRemediesFlow, loadPinsFlow, markPinFlow];

export default remediesFlow;
